// extracted by mini-css-extract-plugin
export default {"editorWrapper":"NLtWj","form":"ilGyW","input":"gnimf","dropZoneRoot":"sFYDG","dropZone":"sVHjd","label":"gp6Yv","editBtnWrapper":"YYgKp","basicInfo":"cecAk"};